// Reserved FaceClipPlayer clip names for the Stream First/Last Frame feature.
//
// The Stream First Frame / Stream Last Frame EVENT-graph actions publish a
// queued sentence's first (or last) ARKit frame as a 1-frame clip under these
// names (EventRuntime.js). The First Frame Pose / Last Frame Pose FACE-graph
// source nodes emit these same names into the clip-weight map (GraphEvaluator.js),
// and both the GLB head (HeadModel) and the splat rig (OGSModel) resolve them
// through faceClipPlayer.getBlendedWeights when LiveLink is off — so one string
// wires publisher → consumer across both avatar types. Kept in one module so the
// two sides can never drift.
export const STREAM_FIRST_FRAME_CLIP = '__stream_first_frame__'
export const STREAM_LAST_FRAME_CLIP  = '__stream_last_frame__'
